<template>
  <div id="app" class="layout_mian" v-cloak>
    <el-container :style="constyle">
      <!--<div style="width:186px;height:56px;background-color:#e31d19">供应商系统</div>-->

      <el-aside width="186px" style="background-color: rgb(238, 241, 246)" v-if="this.$root.showLeftMenu">
        <el-menu :default-openeds="opedids">
          <a href="/">
            <el-submenu index="0" class="first_submenu">
              <template slot="title">
                如家供应商平台
              </template>
            </el-submenu>
          </a>
          <el-submenu index="1" class="second_submenu submenu_item active_item">
            <template slot="title">
              <i class="el-icon-tickets"></i>订单管理
            </template>
            <router-link :to="{path:'/home'}">
              <el-menu-item index="1-1">首页</el-menu-item>
            </router-link>
            <router-link :to="{path:'/directOrderList',query:{statusIndex:-1, pagekey:new Date().getTime(),pagesn:'directOrderList'}}" :class="this.$root.pagesn=='directOrderList'?'router-link-active':''">
              <el-menu-item index="1-2">直营订单</el-menu-item>
            </router-link>
            <router-link :to="{path:'/franchiseOrderList',query:{statusIndex:-1,pagekey:new Date().getTime(),pagesn:'franchiseOrderList'}}" :class="this.$root.pagesn=='franchiseOrderList'?'router-link-active':''">
              <el-menu-item index="1-3">特许订单</el-menu-item>
            </router-link>
            <router-link :to="{path:'/spellOrderList',query:{pagekey:new Date().getTime(),statusIndex:'',pagesn:'spellOrderList'}}" :class="this.$root.pagesn=='spellOrderList'?'router-link-active':''">
              <el-menu-item index="1-4">拼团订单</el-menu-item>
            </router-link>
            <router-link :to="{path:'/materialOrderList',query:{statusIndex:-1,pagekey:new Date().getTime(),pagesn:'materialOrderList'}}" :class="this.$root.pagesn=='materialOrderList'?'router-link-active':''">
              <el-menu-item index="1-11">原材料订单</el-menu-item>
            </router-link>
            <router-link :to="{path:'/evaluate',query:{pagekey:new Date().getTime()}}">
              <el-menu-item index="1-5">
                订单评价
              </el-menu-item>
            </router-link>
            <router-link :to="{path:'/SKUevaluate',query:{pagekey:new Date().getTime()}}">
              <el-menu-item index="1-5">
                产品评价
              </el-menu-item>
            </router-link>
            <router-link :to="{path:'/ReceiveObjectionList',query:{status:1}}">
              <el-menu-item index="1-8">收货异议<span v-html="getNum(1)" style="color:#e31d19;font-weight:bold"></span></el-menu-item>
            </router-link>
            <router-link :to="{path:'/preorderlist',query:{st:st}}">
              <el-menu-item index="1-9">
                预新增订单导入
              </el-menu-item>
            </router-link>
            <!--<router-link :to="{path:'/UnConfirmPO',query:{status:1}}">
    <el-menu-item index="1-9">历史未完成订单状态确认</el-menu-item>//供应商添加目录模块
  </router-link>-->
            <!--<router-link :to="{path:'/directOrderList',query:{statusIndex:'200',pagekey:new Date().getTime()}}">
    <el-menu-item index="1-9">提前付款申请</el-menu-item>
  </router-link>-->
            <el-submenu index="1-6">
              <template slot="title">
                付款管理
              </template><router-link :to="{path:'/supplierpaylist',query:{st:st}}">
                <el-menu-item index="1-6-1">
                  付款列表
                </el-menu-item>
              </router-link><router-link :to="{path:'/supplierinvoicelist',query:{st:st}}">
                <el-menu-item index="1-6-2">
                  开票列表
                </el-menu-item>
              </router-link>
            </el-submenu>
            <el-submenu index="1-10">
              <template slot="title">
                特许订单加购
              </template>
              <router-link :to="{path:'/licensedProducts',query:{st:st}}">
                <el-menu-item index="1-10-1">
                  特许产品加购
                </el-menu-item>
              </router-link>
              <router-link :to="{path:'/shoppingCart',query:{st:st}}">
                <el-menu-item index="1-10-2">
                  购物车
                </el-menu-item>
              </router-link>
              <router-link :to="{path:'/supplierSubmitList',query:{st:st}}">
                <el-menu-item index="1-10-3">
                  提交列表
                </el-menu-item>
              </router-link>
            </el-submenu>

          </el-submenu>
          <el-submenu index="4" class="submenu_item">
            <template slot="title">
              <i class="el-icon-search"></i>查询相关
            </template>
            <router-link :to="{path:'/direct_bill',query:{statusIndex:0}}">
              <el-menu-item index="4-1">
                直营订单对账单
              </el-menu-item>
            </router-link><router-link :to="{path:'/franchise_sendbill',query:{statusIndex:0}}">
              <el-menu-item index="4-2">
                特许订单线上支付对账

              </el-menu-item>
            </router-link> <router-link :to="{path:'/franchise_sendwithdrawalbill',query:{statusIndex:0}}">
              <el-menu-item index="4-3">
                特许订单线上支付提现

              </el-menu-item>
            </router-link>
            <router-link :to="{path:'/franchise_voucherbill',query:{statusIndex:0}}">
              <el-menu-item index="4-4">
                特许订单线下支付对账

              </el-menu-item>
            </router-link>
            <router-link :to="{path:'/rebatelist',query:{st:st}}">
              <el-menu-item index="4-5">
                渠道使用服务费账单
              </el-menu-item>
            </router-link>
            <router-link :to="{path:'/orderreport'}">
              <el-menu-item index="4-6">订单报表查询</el-menu-item>
            </router-link>
            <router-link :to="{path:'/hotellist',query:{pagekey:new Date().getTime()}}">
              <el-menu-item index="4-7">
                酒店查询
              </el-menu-item>
            </router-link>
            <router-link :to="{path:'/hotelDesignDrawing',query:{st:st}}">
              <el-menu-item index="4-8">
                酒店平面设计图查询
              </el-menu-item>
            </router-link>
          </el-submenu>
          <el-submenu index="5" class="submenu_item">
            <template slot="title">
              <i class="el-icon-goods"></i>商品管理
            </template>
            <!-- 洗涤类供应商按服务资料模式维护，不展示 SKU 产品列表入口。 -->
            <router-link v-if="!isLaundrySupplier()" :to="{path:'/prodlist',query:{st:st}}">
              <el-menu-item index="5-1">
                商品列表
              </el-menu-item>
            </router-link>
            <router-link v-if="!isLaundrySupplier()" :to="{path:'/allprodlist',query:{st:st}}">
              <el-menu-item index="5-2">
                产品报表
              </el-menu-item>
            </router-link>
            <router-link :to="{path:'/logisticsaftersales',query:{st:st}}">
              <el-menu-item index="5-3">
                物流售后信息维护
              </el-menu-item>
            </router-link>
          </el-submenu>
          <el-submenu index="6" class="submenu_item">
            <template slot="title">
              <i class="el-icon-office-building"></i>工程相关信息
            </template>
            <router-link :to="{path:'/nonStandardReport',query:{pagekey:new Date().getTime()}}">
              <el-menu-item index="6-1">非标报备</el-menu-item>
            </router-link>
          </el-submenu>
          <el-submenu index="2" class="submenu_item">
            <template slot="title">
              <i class="el-icon-shopping-bag-1"></i>店铺管理
            </template>
            <router-link :to="{path:'/supplierKpiReward',query:{st:st}}">
              <el-menu-item index="2-1">扣分明细</el-menu-item>
            </router-link>
            <router-link :to="{path:'/shopcenter',query:{tab:'t0'}}">
              <el-menu-item index="2-1">店铺logo</el-menu-item>
            </router-link>
            <router-link :to="{path:'/shopcenter',query:{tab:'t66'}}">
              <el-menu-item index="2-2">店铺介绍</el-menu-item>
            </router-link>
            <router-link :to="{path:'/shopcenter',query:{tab:'t1'}}"><el-menu-item index="2-3">店铺公告</el-menu-item></router-link>
            <router-link :to="{path:'/shopcenter',query:{tab:'t2'}}"><el-menu-item index="2-4">联系人管理</el-menu-item></router-link>
            <router-link :to="{path:'/shopcenter',query:{tab:'t3'}}"><el-menu-item index="2-5">银行账户信息</el-menu-item></router-link>
            <router-link :to="{path:'/shopcenter',query:{tab:'t8'}}"><el-menu-item index="2-6">开票信息维护</el-menu-item></router-link>
            <router-link :to="{path:'/shopcenter',query:{tab:'t4'}}"><el-menu-item index="2-7">证照管理</el-menu-item></router-link>
            <router-link :to="{path:'/shopcenter',query:{tab:'t5'}}"><el-menu-item index="2-8">物流管理</el-menu-item></router-link>
            <router-link :to="{path:'/shopcenter',query:{tab:'t9'}}"><el-menu-item index="2-9">货品供货位置</el-menu-item></router-link>
            <!-- 洗涤类供应商按需求拆成两个独立目录：服务范围只读展示，服务设备负责图片维护和提审。 -->
            <router-link v-if="isLaundrySupplier()" :to="{path:'/shopcenter',query:{tab:'t11'}}"><el-menu-item index="2-10">服务范围</el-menu-item></router-link>
            <router-link v-if="isLaundrySupplier()" :to="{path:'/shopcenter',query:{tab:'t12'}}"><el-menu-item index="2-11">服务设备</el-menu-item></router-link>

          </el-submenu>
          <el-submenu index="3" class="submenu_item">
            <template slot="title">
              <i class="el-icon-notebook-2"></i>常见问题
            </template>
            <router-link :to="{path:'/help',query:{tab:'t0'}}">
              <el-menu-item index="3-1">
                直营店订单
              </el-menu-item>
            </router-link>
            <router-link :to="{path:'/help',query:{tab:'t1'}}">
              <el-menu-item index="3-1">
                特许店订单
              </el-menu-item>
            </router-link>
            <router-link :to="{path:'/help',query:{tab:'t2'}}">
              <el-menu-item index="3-2">
                商品管理须知
              </el-menu-item>
            </router-link>
            <router-link :to="{path:'/supplierSurvey',query:{st:st}}">
              <el-menu-item index="3-3">
                供应商问卷调查
              </el-menu-item>
            </router-link>
          </el-submenu>
          <router-link :to="{path:'/managementRegulation'}">
            <el-menu-item index="6" class="submenu_item">
              <i class="el-icon-document"></i>管理条例
            </el-menu-item>
          </router-link>
        </el-menu>
        <div class="foot_text">联系邮箱：gysxtbx.list@homeinns.com</div>
        <div class="foot_text">
          版权所有 © 2016 Homeinns Co.,Ltd All Rights Reserved. 和美酒店管理（上海）有限公司
        </div>
        <div class="foot_text">
          沪ICP备15017896号
          <p class="foot_text">建议使用谷歌浏览器</p>
        </div>
      </el-aside>

      <el-container>

        <el-header style="text-align: right; font-size: 12px" v-if="this.$root.showTopInfo">

          <div style="text-align:right;height:56px;line-height:56px" v-if="userinfo!=null">
            <span style="float:left;font-size:18px;">{{$route.meta.title}}</span>  
            <!--<span style="color:#fff;font-size:16px;font-weight:bold;vertical-align:top" v-if="userinfo!=null">Hi · {{userinfo.loginName}}-{{userinfo.Name}}</span>-->
            <!--<span style="font-size:14px;color:#ffec00;font-weight:bold;vertical-align:top"> {{userinfo.KPI===''?'5.00':userinfo.KPI}}</span>
          <span style="font-size:14px;color:#ffec00;font-weight:bold;vertical-align:top" title="等级说明：优秀（4.61~5.00）合格（4.36~4.6）绩差（4.26~4.35）淘汰（4.25以下）"> {{userinfo.level}}</span>-->
            <span style="color:#fff;font-size:12px;vertical-align:top">Hi · {{userinfo.loginName}}-{{userinfo.Name}} - {{nowTime}}</span>
            <!--<span style="color:#fff;font-size:12px;vertical-align:top">地址：{{userinfo.Adress}}</span>
          <span style="color:#fff;font-size:12px;vertical-align:top">联系方式：{{userinfo.listcontacts[0].tel}}</span>-->
            <!--<span style="color:#fff;font-size:12px;vertical-align:top;cursor:pointer" @click="ChangePassword">消息(<b>2</b>)</span>-->
            <span style="color:#fff;font-size:12px;vertical-align:top;cursor:pointer" @click="ChangePassword">[修改密码]</span>
            <span style="color:#fff;font-size:12px;vertical-align:top;cursor:pointer" @click="logout">[退出]</span>
          </div>
        </el-header>
        <!--<gys-nav :userinfo="userinfo" v-if="this.$root.headershow1" />-->

        <el-main>
          <router-view ref="mainrouter" style="margin:10px 10px 50px 10px;">

          </router-view>
          <el-backtop target=".el-main"></el-backtop>
          <el-tooltip class="item ll" effect="light" placement="left">

            <div slot="content" class="kk" >常见问题</div>
            <div  @click="linkHelp" class="el-backtop1" style="right: 40px; bottom: 40px;"><i class="el-icon-question"></i></div>
          </el-tooltip>
        </el-main>

      </el-container>
    </el-container>



    <globalstyle />
    <loading :title="this.$root.loadingTitle" v-show="this.$root.isLoading==true" />
    <!--<gys-header :userinfo="userinfo" v-if="this.$root.headershow" />-->
    <!--<gys-nav :userinfo="userinfo" v-if="this.$root.headershow1"/>-->
    <!--<router-view style="padding-bottom:100px;" />-->
    <!--<gys-footer v-if="this.$root.headershow2"   style="position:absolute;margin-top:20px;"/>
  <loading :title="this.$root.loadingTitle" v-show="this.$root.isLoading==true" />-->
  </div>
</template>
<script>
  //import GysHeader from "@/components/GysHeader.vue";
  import GysNav from "@/components/GysNav.vue";
  import Loading from "@/components/Loading.vue";
  import GysFooter from "@/components/GysFooter.vue";
  import globalstyle from "@/components/globalstyle.vue";
  import http from '@/common/js/http';
  export default {
    data() {
      return {
        st: new Date().getMonth()+'0'+new Date().getDate() + '0' + new Date().getHours(),
        opedids: ['1'],
        userinfo: null,
        isCollapse: true,
        constyle: {},
        nowTime: '',
        statusCount:[]
      }
    },
    components: {
      GysNav,
      Loading,
      GysFooter,
      globalstyle
    },
    watch: {
      '$route': 'RefreshUser'
    },
    methods: {
      RefreshUser() {
        if (this.$root.isLogin) {
          let navs = this.$root.api.getInfo({}, this);
          navs.then(res => {
            if (res == undefined) {
              return;
            }
            this.getNumAndMsg();
            this.userinfo = res.Data;
          });
        }
        else {
          //不需要验证登录
        }
      },
      isLaundrySupplier() {
        return this.userinfo != null && this.userinfo.isLaundrySupplier === true;
      },
      ChangePassword() {
        this.$router.push('/ChangePassword')
      },
      logout() {
        let params = {
        };
        let accounts = this.$root.api.getAccount(params, this);
        accounts.then(res => {
          this.removeCookie('secret');
          this.removeCookie('token');
          http.redirectSsoSignOutUrl(this);
        });

      },
      getNum(type) {
        if (this.statusCount != null && this.statusCount.length > 0) {
          for (var i = 0; i < this.statusCount.length; i++) {
            if (this.statusCount[i].Type == type && this.statusCount[i].Num>0)
              return '(' + this.statusCount[i].Num + ')';
          }
        }
        return '';
      },
      getNumAndMsg() {
        if (this.statusCount == null || this.statusCount.length==0) {
          let req = this.$root.api.GetSupplierMsgNotifInfo({}, this);
          req.then(res => {
            if (res.Code == 0) {
              this.statusCount = res.Data.SupplierStatusCount;
            }
          });
        }
      },
      timeFormate(timeStamp) {
        let year = new Date(timeStamp).getFullYear();
        let month = new Date(timeStamp).getMonth() + 1 < 10 ? "0" + (new Date(timeStamp).getMonth() + 1) : new Date(timeStamp).getMonth() + 1;
        let date = new Date(timeStamp).getDate() < 10 ? "0" + new Date(timeStamp).getDate() : new Date(timeStamp).getDate();
        let hh = new Date(timeStamp).getHours() < 10 ? "0" + new Date(timeStamp).getHours() : new Date(timeStamp).getHours();
        let mm = new Date(timeStamp).getMinutes() < 10 ? "0" + new Date(timeStamp).getMinutes() : new Date(timeStamp).getMinutes();
        let ss = new Date(timeStamp).getSeconds() < 10 ? "0" + new Date(timeStamp).getSeconds() : new Date(timeStamp).getSeconds();

        let day = new Date(timeStamp).getDay();
        let week = "";
        if (day == 0) week = "星期日";
        if (day == 1) week = "星期一";
        if (day == 2) week = "星期二";
        if (day == 3) week = "星期三";
        if (day == 4) week = "星期四";
        if (day == 5) week = "星期五";
        if (day == 6) week = "星期六";

        let hours = new Date(timeStamp).getHours();
        let apm = "";
        if (hours < 6) apm = "凌晨";
        else if (hours < 9) apm = "早上";
        else if (hours < 12) apm = "上午";
        else if (hours < 13) apm = "中午";
        else if (hours < 17) apm = "下午";
        else if (hours < 19) apm = "傍晚";
        else if (hours < 24) apm = "晚上";

        this.nowTime = year + "年" + month + "月" + date + "日" + " " + hh + ":" + mm + ':' + ss + " " + week + " " + apm + ".";
      },
      nowTimes() {
        this.timeFormate(new Date());
        setInterval(this.nowTimes, 1000);
        this.clear()
      },
      clear() {
        clearInterval(this.nowTimes)
        this.nowTimes = null;
      },
      linkHelp() {
        let route = this.$router.resolve({ path: '/help', query: {tab:'t0'} });
        window.open(route.href, '_blank');
      }
    },
    mounted() {
      
      this.RefreshUser();
      this.nowTimes();
      this.constyle = { height: (document.documentElement.clientHeight - 2) + 'px' };
    }
  }
</script>
<style lang="less" scoped>
  [v-cloak] {
    display:none;
  }
  #app .foot_text {
    text-align: center;
    line-height: 16px;
    margin-top: 8px;
    padding: 0px 5px;
    color: #646464
  }
  #app {
    min-height: 100%;
    height: auto !important;
    height: 100%; /*ie6不识别min-height,如上述处理*/
    position: relative;
  }


  .el-menu-item a {
    color: #0c0d0f;
  }

  .second_submenu {
    margin-top: 56px;
    z-index: 0;
  }
  .first_submenu /deep/ .el-submenu__title:hover {
    background-color: #e31d19;
  }

  .first_submenu {
    background-color: #e31d19;
    position: fixed;
    z-index: 100;
    width: 186px;
  }

    .first_submenu /deep/ .el-submenu__title {
      color: #fff;
      font-size: 21px !important;
      font-family: 楷体;
    }

    .first_submenu /deep/ .el-submenu__icon-arrow {
      display: none;
    }

  .el-main {
    padding:0px;
    border:10px solid #f5f5f5;
  }
 

  .el-header {
    background-color: #e31d19;
    text-align: left !important;
    font-size: 30px !important;
    color: #fff;
    line-height: 56px;
    font-family: 微软雅黑;
    height: 56px !important;
  }

  .el-menu--inline li /deep/ .el-submenu__title {
    padding-left: 35px !important;
    font-size: 12px !important;
    height: 30px !important;
    line-height: 30px !important;
    color: #8a8a8a
  }

  .layout_mian .el-submenu {
    text-align: initial;
  }

  .layout_mian .el-menu-item {
    padding-left: 40px !important;
    min-width: 180px;
    font-size: 12px;
    height: 30px;
    line-height: 30px;
    color: #515a6e;
  }
  /*隐藏整个body的滚动条*/
  body ::-webkit-scrollbar {
    display:none;
  } 
  /*滚动条宽 长,滚动条整体部分，其中的属性有width,height,background,border等。*/
  .layout_mian ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  /*滚动条的滑轨背景颜色,可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果。*/

  .layout_mian ::-webkit-scrollbar-track {
    background-color: #f5f5f5;
    /*-webkit-box-shadow: inset 0 0 3px rgba(0,0,0,0.1);*/
    border-radius: 3px;
  }

  /* 滑块颜色 */

  .layout_mian ::-webkit-scrollbar-thumb {
    background-color: #e4e4e4;
    border-radius: 3px;
  }

    .layout_mian ::-webkit-scrollbar-thumb:hover {
      background-color: #b5b5b5;
    }

  /*滚动条两端的按钮。可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果。*/

  .layout_mian::-webkit-scrollbar-button {
    background-color: #eee;
    display: none;
  }

  /* 横向滚动条和纵向滚动条相交处尖角的颜色 */

  .layout_mian ::-webkit-scrollbar-corner {
    background-color: #8d8d8d;
  }
  /*滑过提示层*/
  .el-tooltip__popper {
    min-width:initial !important;
  }
  /*菜单颜色*/
  .layout_mian .el-menu a .el-menu-item:hover {
    /*background-color: #e31d19;
    color: #fff;*/
    background-color: rgba(227,29,25,0.1);
    color: #e31d19;
    /*border-right: 2px solid #e31d19;*/
  }
  .layout_mian .el-menu-item:hover a {
    color: #fff;
  }
  .layout_mian .router-link-exact-active .el-menu-item {
    /*background-color: #e31d19;
    color: #fff;*/
    background-color: rgba(227,29,25,0.1);
    color: #e31d19;
    border-right: 2px solid #e31d19;
  }
    .layout_mian .submenu_item /deep/ .el-submenu__title {
      height: 35px;
      line-height: 35px;
    }
  .layout_mian .active_item .router-link-active .el-menu-item {
    /*background-color: #e31d19;
    color: #fff;*/
    background-color: rgba(227,29,25,0.1);
    color: #e31d19;
    border-right: 2px solid #e31d19;
  }
  /*常见问题*/
  .el-backtop1:hover {
    background-color: #e3e3e3;
    color: #333
  }
  .el-backtop1 {
    position: fixed;
    background-color: #fff;
    width: 40px;
    height: 40px;
    color: #d3d3d3;
    border-radius: 50%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    font-size: 20px;
    cursor: pointer;
    z-index: 5;
    bottom: 85px !important;
    box-shadow: 0 0 6px 0 rgba(107,66,66,0.4);
  }
  .layout_mian .el-menu-item * {
    vertical-align:top;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue